export default __webpack_public_path__ + "static/media/artboard.cba52553.webp";